var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrows(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_40000124_56869)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_40000124_56869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.0004 35.4193C27.6209 35.4193 35.4198 27.6204 35.4198 17.9999C35.4198 8.37948 27.6209 0.580566 18.0004 0.580566C8.37997 0.580566 0.581055 8.37948 0.581055 17.9999C0.581055 27.6204 8.37997 35.4193 18.0004 35.4193Z",
    fill: "transparent"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.6026 18.0497C20.6026 18.4054 20.4664 18.7611 20.1942 19.0334L11.6658 27.5618C11.1212 28.1065 10.2429 28.1065 9.69849 27.5618C9.15389 27.0173 9.15389 26.139 9.69849 25.5988L17.2475 18.0497L9.69849 10.5006C9.15389 9.95604 9.15389 9.07776 9.69849 8.53759C10.2431 7.993 11.1214 7.993 11.6658 8.53759L20.1942 17.066C20.4665 17.3383 20.6026 17.694 20.6026 18.0497Z",
    fill: "#7D5B0E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1866 18.0497C28.1866 18.4054 28.0505 18.7611 27.7782 19.0334L19.2498 27.5618C18.7052 28.1065 17.8269 28.1065 17.2825 27.5618C16.7379 27.0173 16.7379 26.139 17.2825 25.5988L24.8316 18.0497L17.2825 10.5006C16.7379 9.95604 16.7379 9.07776 17.2825 8.53759C17.827 7.993 18.7053 7.993 19.2498 8.53759L27.7782 17.066C28.0506 17.3383 28.1866 17.694 28.1866 18.0497Z",
    fill: "#7D5B0E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_40000124_56869",
    x: -0.418945,
    y: -0.419434,
    width: 36.8389,
    height: 36.8386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.323611 0 0 0 0 0.32908 0 0 0 0 0.333333 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_40000124_56869"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_40000124_56869",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_40000124_56869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "transparent"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrows);
export default __webpack_public_path__ + "static/media/arrows.87202ae183f3bcfcbd96641db5f10994.svg";
export { ForwardRef as ReactComponent };